import type { BuildingsTab } from '../pages/Buildings';

/**
 * SF-160: single source of truth for the Buildings page's tab order/labels — both
 * DesktopBuildingsShell and MobileBuildingsShell import this instead of each defining their own
 * local array. States tab order explicitly (Build | Raze | Overview, matching the mockup) in
 * exactly one place.
 */
export const BUILDINGS_TABS: readonly { key: BuildingsTab; label: string }[] = [
  { key: 'build', label: 'Build' },
  { key: 'raze', label: 'Raze' },
  { key: 'overview', label: 'Overview' },
];

/**
 * Missing/invalid values fall back to 'build', the pre-existing default. Accepts 'raze' — fixes
 * the standing `/raze` redirect bug (App.tsx) as a side effect of giving `?tab=` a real contract.
 */
export function parseBuildingsTab(value: string | null): BuildingsTab {
  return value === 'raze' || value === 'overview' ? value : 'build';
}
